import { render, staticRenderFns } from "./SendWWEFModal.vue?vue&type=template&id=620f0676&scoped=true"
import script from "./SendWWEFModal.vue?vue&type=script&lang=js"
export * from "./SendWWEFModal.vue?vue&type=script&lang=js"
import style0 from "./SendWWEFModal.vue?vue&type=style&index=0&id=620f0676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f0676",
  null
  
)

export default component.exports